import { SlotStates } from "../../api/models/ScheduleSlotModel";
import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";
import AvailableSlot from "./AvailableSlot";
import BookedSlot from "./BookedSlot";
import CanceledSlot from "./CanceledSlot";
import DoneSlot from "./DoneSlot/index";
import FakeSlot from "./FakeSlot";
import LockedSlot from "./LockedSlot";
import ReservableSlot from "./ReservableSlot";
import ScheduledSlot from "./ScheduledSlot/index";
import UpcomingSlot from "./UpcomingSlot/index";

export default function EventInfo(props: {
  slot: CalendarScheduleSlotModel;
  compact: boolean;
  cancel?: boolean;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  const { slot } = props;
  switch (slot.state) {
    case SlotStates.not_started:
      return <ScheduledSlot {...props} />;
    case SlotStates.done:
      return <DoneSlot {...props} />;
    case SlotStates.upcoming:
    case SlotStates.in_progress:
      return <UpcomingSlot {...props} />;
    case SlotStates.reservable:
      return <ReservableSlot {...props} />;
    case SlotStates.locked:
      return <LockedSlot {...props} />;
    case SlotStates.available:
      return <AvailableSlot {...props} />;
    case SlotStates.booked:
      return <BookedSlot {...props} />;
    case SlotStates.canceled:
    case SlotStates.canceled_by_student:
    case SlotStates.canceled_by_tutor:
    case SlotStates.tutor_absence:
    case SlotStates.student_absence:
    case SlotStates.disconnected_by_system:
    case SlotStates.disconnected:
      return <CanceledSlot {...props} />;
    default:
      return <FakeSlot {...props} />;
  }
}
